import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  show() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("hidden")
      document.body.style.overflow = "hidden"
    }
  }

  hide() {
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }
}

